export default __webpack_public_path__ + "static/media/logo sport (2).77d6fb17.png";